import axios from "axios";
import config from "@/config/env.config.json";
import logger from "@/utils/logger";
import store from "@/store";
import { DateTime } from "luxon";

const envConfig = config[process.env.NODE_ENV];
const consumerBaseUrl = envConfig.consumerApiBaseUrl;
const wordGameApi = {};

// Word Game Words
wordGameApi.getWordGameWordOfTheDay = async () => {
  let response = null;
  // grab the latest date from latestReading
  try {
    await store.dispatch("getLatestReadingsForDevice");
    if (store.state.isLatestReadingToday) {
      const today = DateTime.now().toLocal().toFormat("yyyy-MM-dd");
      const url = `${consumerBaseUrl}/patient_portal/word_game_words?use_date=${today}`;
      console.log("API REQUEST", "GET", url);
      response = await axios.get(url);
      console.log("API RESPONSE", "GET", url, response.status, response.data);
      return response.data.data[0];
    } else {
      return response;
    }
  } catch (error) {
    console.error("API ERROR", "GET", "getWordGameWordOfTheDay", error);
    logger.error(error);
    throw error;
  }
};

wordGameApi.getAllWordGameWords = async () => {
  try {
    const url = `${consumerBaseUrl}/patient_portal/word_game_words`;
    console.log("API REQUEST", "GET", url);
    const response = await axios.get(url);
    console.log("API RESPONSE", "GET", url, response.status, response.data);
    return response.data;
  } catch (error) {
    console.error("API ERROR", "GET", "getAllWordGameWords", error);
    logger.error(error);
    throw error;
  }
};

// Word Games
wordGameApi.createWordGame = async (body) => {
  try {
    const url = `${consumerBaseUrl}/patient_portal/user_profiles/${body.patient_user_profile_id}/word_games`;
    console.log("API REQUEST", "POST", url, body);
    const response = await axios.post(url, body);
    console.log("API RESPONSE", "POST", url, response.status, response.data);
    return response.data;
  } catch (error) {
    console.error("API ERROR", "POST", "createWordGame", error);
    logger.error(error);
    throw error;
  }
};
wordGameApi.updateWordGame = async (body) => {
  try {
    const url = `${consumerBaseUrl}/patient_portal/user_profiles/${body.patient_user_profile_id}/word_games?word_game_word_id=${body.word_game_word_id}`;
    console.log("API REQUEST", "PUT", url, body);
    const response = await axios.put(url, body);
    console.log("API RESPONSE", "PUT", url, response.status, response.data);
    return response.data;
  } catch (error) {
    console.error("API ERROR", "PUT", "updateWordGame", error);
    logger.error(error);
    throw error;
  }
};
wordGameApi.getWordGameRecord = async (
  patientUserProfileId,
  wordGameWordId
) => {
  try {
    const queryParams =
      wordGameWordId !== undefined
        ? `?word_game_word_id=${wordGameWordId}`
        : "";
    const url = `${consumerBaseUrl}/patient_portal/user_profiles/${patientUserProfileId}/word_games${queryParams}`;
    console.log("API REQUEST", "GET", url);
    const response = await axios.get(url);
    console.log("API RESPONSE", "GET", url, response.status, response.data);
    return response.data;
  } catch (error) {
    console.error("API ERROR", "GET", "getWordGameRecord", error);
    logger.error(error);
    throw error;
  }
};

// Word Game Attempts
wordGameApi.saveWordForRow = async (userProfileId, body) => {
  try {
    const url = `${consumerBaseUrl}/patient_portal/user_profiles/${userProfileId}/word_games/${store.state.wordGameId}/word_game_attempts`;
    console.log("API REQUEST", "POST", url, body);
    const response = await axios.post(url, body);
    console.log("API RESPONSE", "POST", url, response.status, response.data);
    return response.data;
  } catch (error) {
    console.error("API ERROR", "POST", "saveWordForRow", error);
    logger.error(error);
    throw error;
  }
};

wordGameApi.getAllGuessedWords = async (userProfileId, wordGameId) => {
  try {
    const url = `${consumerBaseUrl}/patient_portal/user_profiles/${userProfileId}/word_games/${wordGameId}/word_game_attempts`;
    console.log("API REQUEST", "GET", url);
    const response = await axios.get(url);
    console.log("API RESPONSE", "GET", url, response.status, response.data);
    return response.data;
  } catch (error) {
    console.error("API ERROR", "GET", "getAllGuessedWords", error);
    logger.error(error);
    throw error;
  }
};

export default wordGameApi;
